module.exports = __webpack_public_path__ + "img/whs_management_plan.7d63d742.jpg";